export default __webpack_public_path__ + "static/media/mail.147514a1.png";